const regions = ['Karşıyaka', 'Bornova', 'Buca', 'Gaziemir', 'Balçova', 'Narlıdere', 'Çiğli', 'Bayraklı', 'Konak', 'Menemen'];

export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden bg-[#d4a853]">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/images/pages/cta-pattern.webp"
          alt=""
          loading="lazy" decoding="async"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left */}
          <div>
            <p className="font-body text-[#0f1923]/60 text-xs font-semibold tracking-[0.25em] uppercase mb-5">— İletişime Geçin</p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[#0f1923] leading-tight mb-6">
              Projenizi <br />
              <span className="italic">Birlikte Planlayalım</span>
            </h2>
            <p className="font-body text-[#0f1923]/60 text-base leading-relaxed mb-8 max-w-md">
              Karşıyaka&apos;dan Menemen&apos;e, İzmir&apos;in her köşesinde ücretsiz keşif yapıyoruz. Uzman ekibimiz alanınızı yerinde değerlendirsin.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:05362771709"
                className="inline-flex items-center justify-center gap-2 bg-[#0f1923] text-white font-body font-semibold px-8 py-4 rounded-lg hover:bg-[#162030] transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-phone-fill"></i>
                Ücretsiz Keşif İçin Ara
              </a>
              <a
                href="https://wa.me/905362771709"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#0f1923]/30 text-[#0f1923] font-body font-semibold px-8 py-4 rounded-lg hover:bg-[#0f1923] hover:text-white hover:border-[#0f1923] transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-whatsapp-fill"></i>
                Hızlı Teklif İçin WhatsApp
              </a>
            </div>
          </div>

          {/* Right — region tags */}
          <div className="bg-[#0f1923]/10 rounded-2xl p-8">
            <p className="font-body text-[#0f1923]/60 text-xs font-semibold uppercase tracking-widest mb-5">Hizmet Verdiğimiz İlçeler</p>
            <div className="flex flex-wrap gap-2 mb-6">
              {regions.map((r) => (
                <span key={r} className="font-body text-sm text-[#0f1923] bg-white/40 border border-[#0f1923]/15 px-3 py-1.5 rounded-full">
                  {r}
                </span>
              ))}
            </div>
            <div className="border-t border-[#0f1923]/15 pt-5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#0f1923]/10 rounded-full flex-shrink-0">
                  <i className="ri-search-eye-line text-[#0f1923] text-lg"></i>
                </div>
                <div>
                  <p className="font-body text-[#0f1923] text-sm font-semibold">Ücretsiz Keşif</p>
                  <p className="font-body text-[#0f1923]/55 text-xs">Bağlayıcı değil, tamamen ücretsiz</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
